import {greyishBlue100} from "assets/jss/main";
import Badge from "components/Badge";

export default function ActionButton({ icon, label, onClick, selectedCount }) {
    return (
        <button
            onClick={onClick}
            style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 14px",
                borderRadius: "8px",
                border: `1px solid ${greyishBlue100}`,
                backgroundColor: "#ffffff",
                fontSize: "13px",
                color: "#111827",
                cursor: "pointer",
                fontFamily: "inherit",
            }}
        >
            {icon}
            {label}
            {selectedCount > 0 && (
                <Badge rounded>{selectedCount}</Badge>
            )}
        </button>
    );
}
